module.exports = __webpack_public_path__ + "img/Delicious Drinks.40b54299.jpg";